import { UserStatEntryType } from '../../stat/UserStatEntryType';

export enum NewLoaderFacts {
    PRE_INIT_STARTED,
    PRE_RUN_STARTED,
    POST_RUN_STARTED,
    RUNTIME_INITIALIZED,
}

export const newLoaderClientFactsMap: Map<NewLoaderFacts, UserStatEntryType> = new Map([
    [NewLoaderFacts.PRE_INIT_STARTED, UserStatEntryType.client_new_loader_pre_init_started],
    [NewLoaderFacts.PRE_RUN_STARTED, UserStatEntryType.client_new_loader_pre_run_started],
    [NewLoaderFacts.POST_RUN_STARTED, UserStatEntryType.client_new_loader_post_run_started],
    [NewLoaderFacts.RUNTIME_INITIALIZED, UserStatEntryType.client_new_loader_runtime_initialized]
]);
